module.exports = __webpack_public_path__ + "static/media/Microsoft.49778fbd.png";